'use client'

import { useCachedCourseUnitTimeProgressSWR } from '~/app/actions/progress'
import { SupportedLocales } from '~/types'

interface CourseProgressIndicatorProps {
  courseId: string
  locale: SupportedLocales
}

export default function CourseProgressIndicator({
  courseId,
  locale,
}: CourseProgressIndicatorProps) {
  const { data: progress } = useCachedCourseUnitTimeProgressSWR({
    courseId,
    locale,
  })

  if (!progress || progress.totalUnits === 0) {
    return null
  }

  const { progressPercentage, completedUnits, totalUnits, completedMinutes, totalMinutes } =
    progress

  const isNotStarted = completedMinutes === 0
  const isComplete =
    progressPercentage >= 100 || (totalMinutes > 0 && completedMinutes >= totalMinutes)

  const statusText = isNotStarted
    ? 'Noch nicht begonnen'
    : isComplete
      ? 'Abgeschlossen'
      : `${completedUnits}/${totalUnits} Units`

  return (
    <div className="mb-2 px-0">
      <div className="space-y-1">
        <div className="flex items-center justify-between text-[10px]">
          <span className="font-semibold text-primary-100">{statusText}</span>
          <span className="text-gray-500 text-[9px]">
            {completedMinutes}/{totalMinutes} min
          </span>
        </div>
        <div className="relative h-1.5 w-full bg-gray-200 rounded-full overflow-hidden">
          <div
            className="absolute left-0 top-0 bottom-0 bg-primary-100 transition-all duration-500 ease-out"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
        <div className="text-[8px] text-gray-400 text-right">{progressPercentage}%</div>
      </div>
    </div>
  )
}
